import { motion } from "framer-motion";
import { RefreshCw, Calendar } from "lucide-react";

import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

// FIN-6 — HeroAssinaturasCard amber.

const fmtBRL = (v) => Number(v ?? 0).toLocaleString("pt-BR", {
  style: "currency", currency: "BRL",
});

export default function HeroAssinaturasCard({ summary, loading }) {
  const activeCount = Number(summary?.active_count ?? 0);
  const monthlyTotal = Number(summary?.monthly_total ?? 0);
  const annualTotal = Number(summary?.annual_total ?? 0);
  const nextBilling = summary?.next_billing;

  return (
    <Card
      variant="elevated"
      className="glass-card-strong gradient-border-cyan glow-hover p-6 md:p-8 relative overflow-hidden"
      data-testid="sub-hero"
    >
      <div className="flex items-start justify-between mb-5 gap-4 flex-wrap">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-10 h-10 rounded-xl bg-status-warning/15 border border-status-warning/30 flex items-center justify-center shrink-0">
            <RefreshCw className="w-5 h-5 text-status-warning" aria-hidden="true" />
          </div>
          <div className="min-w-0">
            <h2 className="font-display font-bold text-foreground text-h2 leading-tight" data-testid="sub-hero-title">
              Assinaturas ativas
            </h2>
            <p className="text-caption text-foreground-muted">Recorrências do mês</p>
          </div>
        </div>

        {nextBilling && (
          <Badge variant="info" className="self-start inline-flex items-center gap-1.5 px-2.5 py-1 text-caption font-normal" data-testid="sub-hero-next-billing">
            <Calendar className="w-3.5 h-3.5" aria-hidden="true" />
            Próxima: {nextBilling.name} em {nextBilling.days_to_next_billing}d
          </Badge>
        )}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35, ease: [0.2, 0.8, 0.2, 1] }}
        className="mb-3 flex items-baseline gap-3"
        data-testid="sub-hero-amount"
      >
        <div
          className={cn(
            "font-display font-bold leading-[0.95] tracking-[-0.02em] tabular-nums",
            "text-[64px] md:text-[80px] lg:text-[96px]",
            "text-status-warning",
          )}
        >
          {loading ? "…" : activeCount}
        </div>
        <span className="text-caption text-foreground-muted uppercase font-semibold pb-3" style={{ letterSpacing: "0.10em" }}>
          serviço{activeCount === 1 ? "" : "s"}
        </span>
      </motion.div>

      <p className="text-caption text-foreground-muted" data-testid="sub-hero-footer">
        {loading ? "…" : `${fmtBRL(monthlyTotal)} / mês · ${fmtBRL(annualTotal)} / ano`}
      </p>
    </Card>
  );
}
